module.exports = __webpack_public_path__ + "img/god-ape-quest-banner.64e60da0.jpg";